/*
Validation functions used in vuex store.
 */

export function isValidSection1(p){
  const a =  p.projectName !== null && p.projectName.length > 0;
  const b = p.owner !== null && p.owner.length > 0;
  const c = p.city !== null && p.city.length > 0;
  const d = p.state !== null;

  const v = a && b && c && d;
  console.log("Section 1", v);
  return v

}

export function isValidSection2a(p){
  const v = [1,2,3].includes(p.pavementType)
    && p.segmentLengthFt > 0
    && p.segmentWidthFt > 0
    && p.intersectionPresent !== null
  console.log("Section 2a", v);
  return v
}

export function isValidSection2b(p){
  const currYear = new Date().getFullYear();
  const v = p.lastPCRYear >= 1900
    && p.lastPCRYear <= currYear
    && p.lastPCRReading >= 0
    && p.lastPCRReading <= 100
    && p.lastTreatmentYear >= 1900
    && p.lastTreatmentYear <= currYear
    && [0, 1, 2, 3].includes(p.lastKnownTreatment);

  console.log("Section 2b", v);
  return v
}

export function isValidSection2c(p){
  const v = p.hasParkingLanes !== null
    && p.hasShoulder !== null
    && p.hasBikeLane !== null
    && p.hasCurb !== null;

  console.log("Section 2c", v);
  return v
}

export function isValidSection2d(p){
  const v = p.hasConcreteLayers !== null
    && p.hasTreatedBase !== null
    && p.hasShallowUtilities !== null
    && p.hasGeotextiles !== null
    && p.hasOtherSubsurface !== null;
  console.log("Section 2d", v);
  return v
}

export function isValidSection3(p){
  const v = p.alligatorCrackingSeverity !== null
    && p.longitudinalCrackingSeverity !== null
    && p.transverseCrackingSeverity !== null
    && p.blockCrackingSeverity !== null
    && p.ruttingSeverity !== null
    && p.bleedFlushSeverity !== null
    && p.ravelSeverity !== null
    && p.patchingSeverity !== null
      && !(p.alligatorCrackingSeverity > 0 && p.alligatorCrackingExtent == null);

  console.log("Section 3", v);
  return v
}

export function isValidSection4(p){
  const v = p.isWheelPathFlushing !== null
    && p.requireSmoothMacroTexture !== null
    && p.requireMaintainCurbReveal !== null
    && p.existingSubgradeCbrUnderThreshold !== null

  console.log("Section 4", v);
  return v
}
